<template>
  <div class="app-main-inner app-main-page-tab">
    1111
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
export default {
  name: 'FileHistoryTab',
  components: {},
  data() {
    return {
      loading: false
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
